import axios from 'axios';

const url=process.env.REACT_APP_BASE_URL
const url2=process.env.REACT_APP_BASE_URL




export const postOnlineTransferData=async(data,setAlertMessage,setErrOpen,setAlertType,setFieldValue,setOpenLoader)=>{
    try {
        setOpenLoader(true)
        await axios.post(`${url}/account_registration`,{
            account_holder_name:data.holder_name,
            account_number:data.account_number,
            ifsc_code:data.ifsc_code,
            bank_name:data.bank_name,
            agent_code:sessionStorage.getItem('user_code'),
            type_of_account:'online_bank'
        },{
            headers:{
                'Content-Type':'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('UserToken')}`
            }
        })
        .then((res)=>{
            if(res.status===201){
                setOpenLoader(false)
                setAlertMessage("Account registered successfully")
                setAlertType("success")
                setErrOpen(true)
                setFieldValue('holder_name','')
                setFieldValue('account_number','')
                setFieldValue('ifsc_code','')
                setFieldValue('bank_name','')
            }
            
        })
        console.log(data);
        
    } catch (error) {
            setOpenLoader(false)
            setAlertMessage(error.response&&error.response.data.error?error.response.data.error:"Something went wrong")
            setAlertType("error")
            setErrOpen(true)
    }
}

export const postUpiData=async(upiid,verifyData,setAlertMessage,setErrOpen,setAlertType,setVerified,setFieldValue,setVerifyResponse,setOpenLoader)=>{
    try {
        setOpenLoader(true)
        await axios.post(`${url}/account_registration`,{
            upi_id:upiid,
            name_at_bank:verifyData,
            type_of_account:'upi'
        },{
            headers:{
                'Content-Type':'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('UserToken')}`
            }
        })
        .then((res)=>{
            setOpenLoader(false)
            if(res.status===201){
                setVerified(false)
                setAlertMessage("Account registered successfully")
                setAlertType("success")
                setErrOpen(true)
                setFieldValue('upi_id','')
                setVerifyResponse(null)
               
            }
            
        })
        // console.log(data);
        
    } catch (error) {
        setOpenLoader(false)
            setAlertMessage("Something went wrong")
            setAlertType("error")
            setErrOpen(true)
    }
}


export const postCdmData=async(value,setAlertMessage,setErrOpen,setAlertType,setOpenLoader,setFieldValue)=>{
    console.log("hit");
    try {
        setOpenLoader(true)
        await axios.post(`${url}/account_registration`,{
            address:value.address,
            agent_code:value.agent_code,
            agent_name:value.name,
            branch_code:value.branch_code,
            branch_name:value.bank_branch,
            city:value.city,
            bank:value.bank_name,
            district:value.district,
            mobile_number:value.mobile,
            state:value.state,
            type_of_account:'cash_deposit_machine'
        },{
            headers:{
                'Content-Type':'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('UserToken')}`
            }
        })
        .then((res)=>{
            setOpenLoader(false)
            if(res.status===201){
                setAlertMessage("Account registered successfully")
                setAlertType("success")
                setErrOpen(true)
                setFieldValue('branch_code','')
                setFieldValue('branch_name','')
                setFieldValue('address','')
                setFieldValue('city','')
                setFieldValue('bank','')
               
            }
            
        })
        // console.log(data);
        
    } catch (error) {
        setOpenLoader(false)
            setAlertMessage("Something went wrong")
            setAlertType("error")
            setErrOpen(true)
    }
}



export const postVanData=async(value,setAlertMessage,setErrOpen,setAlertType,setOpenLoader)=>{
    try {
        setOpenLoader(true)
        await axios.post(`${url}/account_registration`,{
            email_id:value.email_id,
            mobile:value.mobile_number,
            name:value.agent_name,
            bank:value.bank,
            type_of_account:'virtual_account'
        },{
            headers:{
                'Content-Type':'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('UserToken')}`
            }
        })
        .then((res)=>{
            setOpenLoader(false)
            if(res.status===201){
                setVerified(false)
                setAlertMessage("Account registered successfully")
                setAlertType("success")
                setErrOpen(true)
                setFieldValue('upi_id','')
                setVerifyResponse(null)
               
            }
            
        })
        // console.log(data);
        
    } catch (error) {
        setOpenLoader(false)
            setAlertMessage("Something went wrong")
            setAlertType("error")
            setErrOpen(true)
    }
}


export const postBankDepositData=async(value,setAlertMessage,setErrOpen,setAlertType,setOpenLoader,setFieldValue)=>{
    setOpenLoader(true)
    try {
        await axios.post(`${url}/account_registration`,{
            agent_name:value.agent_name,
            bank_branch_name:value.bank_branch,
            bank_code:value.branch_code,
            bank_district:value.district,
            bank_name:value.bank_name,
            bank_state:value.state,             
            ifsc_code:value.ifsc_code,
            type_of_account:'cash_deposit_bank'
        },{
            headers:{
                'Content-Type':'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('UserToken')}`
            }
        })
        .then((res)=>{
            setOpenLoader(false)
            if(res.status===201){
                setAlertMessage("Account registered successfully")
                setAlertType("success")
                setErrOpen(true)
                setFieldValue('bank_name','')
                setFieldValue('branch_code','')
                setFieldValue('bank_branch','')
                setFieldValue('ifsc_code','')  
                
               
            }
            
        })
        // console.log(data);
        
    } catch (error) {
        console.log("hitt",error);
            setOpenLoader(false)
            setAlertMessage("Something went wrong")
            setAlertType("error")
            setErrOpen(true)
    }
}


export const GetBankDetails=async(setData)=>{
    try {
        await axios.get(`${url2}/bank_info`,{
            headers:{
                'Content-Type':'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('UserToken')}`
            }
        })
       .then((res)=>{
            setData(res.data)
       })
        
    } catch (error) {
        console.log(error);
    }
}


export const GetIfscDetails=async(ifsc,setData,setFieldValue,validateForm)=>{
    // let reload=increment
    try {
        await axios.post(`${url2}/ifsc_info`,{ifsc_code:ifsc},{
            headers:{
                'Content-Type':'application/json',
                'Authorization':`Bearer ${sessionStorage.getItem('UserToken')}`
            }
        })
       .then(async(res)=>{
        
            setData(res.data)
           await setFieldValue('bank_name', res.data.bank)
           await setFieldValue('branch_code', res.data.branch_code)
           await setFieldValue('bank_branch', res.data.branch)
           await setFieldValue('address', res.data.address)
          
        })
       .then(()=>{
        setTimeout(()=>{
            validateForm()
        },2000)
       })
        
        
    } catch (error) {
        console.log(error);
    }
}